import * as React from "react";
const ThumbsDown = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1862_4443"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="13"
        height="13"
      >
        <rect x="0.5" y="0.710938" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1862_4443)">
        <path
          d="M2 8.71094C1.73333 8.71094 1.5 8.61094 1.3 8.41094C1.1 8.21094 1 7.9776 1 7.71094V6.71094C1 6.6526 1.00625 6.5901 1.01875 6.52344C1.03125 6.45677 1.05 6.39427 1.075 6.33594L2.575 2.81094C2.65 2.64427 2.775 2.5026 2.95 2.38594C3.125 2.26927 3.30833 2.21094 3.5 2.21094H7.5C7.775 2.21094 8.01042 2.30885 8.20625 2.50469C8.40208 2.70052 8.5 2.93594 8.5 3.21094V8.29844C8.5 8.43177 8.47292 8.55885 8.41875 8.67969C8.36458 8.80052 8.29167 8.90677 8.2 8.99844L5.4875 11.6984C5.3625 11.8151 5.21458 11.8859 5.04375 11.9109C4.87292 11.9359 4.70833 11.9068 4.55 11.8234C4.39167 11.7401 4.27708 11.6234 4.20625 11.4734C4.13542 11.3234 4.12083 11.1693 4.1625 11.0109L4.725 8.71094H2ZM10.5 2.21094C10.775 2.21094 11.0104 2.30885 11.2063 2.50469C11.4021 2.70052 11.5 2.93594 11.5 3.21094V7.71094C11.5 7.98594 11.4021 8.22135 11.2063 8.41719C11.0104 8.61302 10.775 8.71094 10.5 8.71094C10.225 8.71094 9.98958 8.61302 9.79375 8.41719C9.59792 8.22135 9.5 7.98594 9.5 7.71094V3.21094C9.5 2.93594 9.59792 2.70052 9.79375 2.50469C9.98958 2.30885 10.225 2.21094 10.5 2.21094Z"
          fill="#E5637F"
        />
      </g>
    </svg>
  );
};
export default ThumbsDown;
